import { Select } from '@mantine/core';
import { AdPlatform } from '@marketing-tool/shared';

import { useGame } from '../../data/games';

export const PlatformSelector = (props: {
    id: string;
    gameId: string;
    value?: AdPlatform;
    onChange: (platform: AdPlatform) => void;
    label?: string;
    w?: number | string;
}) => {
    const { id, gameId, value, onChange, label, w } = props;
    const game = useGame(gameId);
    const data: { value: string; label: string }[] = [];
    Object.entries(AdPlatform).forEach(([name, value]) => {
        if (game?.platforms.includes(value)) {
            data.push({ label: name, value });
        }
    });
    return (
        <Select
            id={id}
            value={value ?? null}
            onChange={(value) => {
                if (value) onChange(value as AdPlatform);
            }}
            data={data}
            label={label}
            placeholder="Select a platform"
            size="sm"
            w={w}
        />
    );
};
